import { render } from "./BlogSidebarImplants.vue?vue&type=template&id=6220e9a9"
import script from "./BlogSidebarImplants.vue?vue&type=script&lang=js"
export * from "./BlogSidebarImplants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__